import React from 'react'

import type { MediaComponent, DrupalMediaBase } from './types'

export interface MediaAPIImage extends DrupalMediaBase {
	__typename: 'media__api_image'
	alt?: string
	src: string
}

const MediaAPIImageComponent: MediaComponent<MediaAPIImage> = ({ className, media, title }) => (
	<img className={className} src={media.src} alt={media.alt} title={title} />
)

export default MediaAPIImageComponent
